<div class="heatmap-container">
    <div id="heatmapContainer">
        <div class="overlay" [ngStyle]="{'background-image':'url('+ overlay +')'}"></div>
        
    </div>
    <!-- <div class="img" [ngStyle]="{ 'background-image': 'url(' + image + ')'}"> -->
    <div class="img-heatmap">
    <img [src]="image" (load)="imageLoaded($event)" />
    </div>
</div>